<div class="header bg-gradient-danger py-8 py-lg-9">
  <div class="container">
    <div class="header-body text-center mb-6 mt--6">
      <div class="row justify-content-center">
        <div class="col-lg-9 col-md-12">
          <h1 class="text-white">Minha assinatura</h1>
          <p class="text-lead text-white">Escolha o plano ideal para o seu momento e compare o que você já utiliza hoje.</p>
        </div>
      </div>
    </div>
  </div>
  <div class="separator separator-bottom separator-skew zindex-100">
    <svg x="0" y="0" viewBox="0 0 2560 100" preserveAspectRatio="none" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <polygon class="fill-default" points="2560 0 2560 100 0 100"></polygon>
    </svg>
  </div>
</div>

<div class="mt--250 pb-5 pl-5 pr-5">
  <div class="row justify-content-center">
    <div class="col-12">
      <div class="text-center">
        <button type="button" class="btn btn-default my-2 mr-md-2" [routerLink]="['/settings']">Voltar ao sistema</button>
        <button type="button" class="btn btn-primary my-2"
                *ngIf="showPendingCheckoutAction()"
                (click)="openPendingCheckout()"
                [disabled]="!mySubscription?.pendingCheckoutUrl">
          {{ pendingCheckoutActionLabel() }}
        </button>
        <button type="button" class="btn btn-danger my-2 px-4"
                *ngIf="canCancelSubscription()"
                (click)="confirmCancellation()">
          Cancelar renovação
        </button>
      </div>
    </div>
  </div>

  <div class="row justify-content-center" *ngIf="loading">
    <div class="col-12 col-lg-8">
      <div class="card bg-secondary shadow border-0">
        <div class="card-body text-center py-5">Carregando informações da assinatura...</div>
      </div>
    </div>
  </div>

  <div class="row justify-content-center" *ngIf="!loading && loadError">
    <div class="col-12 col-lg-8">
      <div class="card bg-secondary shadow border-0">
        <div class="card-body text-center py-5">
          Não foi possível carregar os dados da assinatura.
          <div class="mt-3">
            <button class="btn btn-primary" type="button" (click)="loadData()">Tentar novamente</button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="!loading && !loadError">
    <div class="alert alert-info mb-4" *ngIf="mySubscription?.pendingPlanChangeType === 'DOWNGRADE' && mySubscription?.pendingPlanName">
      Mudança para o plano <strong>{{ mySubscription?.pendingPlanName | titlecase }}</strong> agendada para o próximo ciclo.
    </div>
    <div class="text-center mb-2 mt-2">
      <div class="toggle-btn-group toggle-btn-group-lg mobile-bottom" data-tour="task-view-toggle">
        <button role="button" [title]="'task.views.list.title' | translate"
                [className]="'toggle-btn toggle-btn-lg pr-4 pl-4 ' + (billingPeriod === 'MONTHLY' ? 'selected' : '')" class="toggle-btn"
                (click)="selectBillingPeriod('MONTHLY')" (touchstart)="selectBillingPeriod('MONTHLY')"
                type="button">Mensal
        </button>
        <button role="button" [title]="'task.views.kanban.title' | translate"
                [className]="'toggle-btn toggle-btn-lg pr-4 pl-4 ' + (billingPeriod === 'ANNUAL' ? 'selected' : '')" class="toggle-btn"
                (click)="selectBillingPeriod('ANNUAL')" (touchstart)="selectBillingPeriod('ANNUAL')"
                type="button">Anual<br/>Economize 2 meses
        </button>
      </div>
    </div>

    <div class="row justify-content-center m-2">
      <div class="col-12 col-lg-6">
        <section class="billing-coupon-bar" aria-label="Cupom de desconto">
          <label class="billing-coupon-label mb-0" for="billing-coupon">
            <i class="fa-solid fa-tag" aria-hidden="true"></i>
            <span>Cupom de desconto</span>
          </label>
          <div class="billing-coupon-controls">
            <input #couponInput id="billing-coupon" class="form-control form-control-alternative billing-coupon-input" type="text" autocomplete="off"
                   [value]="couponCode" (input)="couponCode = couponInput.value" (keyup.enter)="applyCoupon()"
                   placeholder="Digite seu cupom">
            <button class="btn billing-coupon-submit" type="button" (click)="applyCoupon()" [disabled]="couponApplying || !!loadingPlan">
              {{ couponApplying ? 'Aplicando...' : 'Aplicar' }}
            </button>
          </div>
        </section>
      </div>
    </div>

    <section class="mb-4">
      <div class="row">
        <div class="col-12 col-md-6 col-xl mb-4" *ngFor="let plan of catalog">
          <div class="card subscription-plan-card h-100"
               [class.subscription-plan-card-current]="isCurrentPlan(plan)">
            <span class="subscription-plan-badge" [class.subscription-plan-badge-warning]="isCancellationScheduled() || isTrialExpired()" *ngIf="isCurrentPlan(plan)">
              {{ getCurrentPlanBadgeLabel() }}
            </span>

            <div class="card-body subscription-plan-header px-lg-4">
              <div class="text-center text-default subscription-plan-name">{{ plan.name | titlecase }}</div>

              <div class="text-center text-muted subscription-plan-original-price" *ngIf="hasCouponDiscount(plan)">{{ formatCurrency(getOriginalPlanPrice(plan)) }}</div>
              <div class="text-center text-default subscription-plan-price">{{ isFreePlan(plan) ? 'Gratuito' : formatCurrency(getPlanPrice(plan)) }}</div>
              <div class="text-center text-muted subscription-plan-period">
                <small>{{ getPlanPeriodLabel(plan) }}</small>
                <span class="subscription-plan-saving" *ngIf="getCouponLabel(plan)">{{ getCouponLabel(plan) }}</span>
                <span class="subscription-plan-saving" *ngIf="getAnnualDiscountLabel(plan)">{{ getAnnualDiscountLabel(plan) }}</span>
              </div>

              <div class="text-center">
                <button [ngClass]="isCurrentPlan(plan) ? 'btn btn-outline-primary' : 'btn btn-primary' " type="button" [disabled]="!canCheckout(plan)" (click)="startCheckout(plan)" [attr.aria-label]="(isDowngrade(plan) ? 'Agendar mudança de plano no próximo ciclo para ' : 'Autorizar assinatura recorrente do plano ') + plan.name">
                  {{ getPlanButtonLabel(plan) }}
                </button>
              </div>
            </div>

            <div class="card-body subscription-plan-features px-4 py-4">
              <ul class="list-unstyled mb-0">
                <li *ngFor="let service of plan.services">
                  <i class="fa-solid fa-circle-check text-success" aria-hidden="true"></i>
                  <span><strong>{{ service.quantity }}</strong> {{ ('billing.services.' + (service.service | lowercase)) | translate }}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="mb-5 mb-md-3">
      <h3 class="text-default mb-5 mb-md-3">Tabela comparativa</h3>
      <div class="card shadow border-0">
        <div class="table-responsive">
          <table class="table table-sm table-hover mb-0">
          <thead>
            <tr>
              <th>Serviço</th>
              <th class="text-center" *ngFor="let plan of catalog">
                {{ plan.name | uppercase }}
                <span class="badge badge-success ml-2" *ngIf="isCurrentPlan(plan)">Atual</span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let fixed of fixedComparisonItems">
              <td>{{ fixed.label }}</td>
              <td class="text-center" *ngFor="let plan of catalog">
                <i class="fa-solid fa-circle-check text-success" *ngIf="!isFreePlan(plan) || fixed.key !== 'finance_management'"></i>
                <i class="fa-solid fa-circle-xmark" *ngIf="isFreePlan(plan) && fixed.key === 'finance_management'"></i>
              </td>
            </tr>
            <tr *ngFor="let service of comparisonServices">
              <td>{{ ('billing.services.' + (service | lowercase)) | translate }}</td>
              <td class="text-center" *ngFor="let plan of catalog">
                {{ getServiceQuantity(plan, service) !== null ? getServiceQuantity(plan, service) : '-' }}
              </td>
            </tr>
          </tbody>
          </table>
        </div>
      </div>
    </section>

    <div class="alert alert-warning mt-3 mb-0" *ngIf="hasNoSubscription()">
      Nenhuma assinatura ativa encontrada para este tenant.
    </div>
  </div>
</div>
